import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './ForgotPasswordForm.css';

const EyeIcon = ({ show }) => (
  show ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  )
);

// Step 1 — Enter email
const EmailStep = ({ onSubmit }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ email });
  };

  return (
    <div className="fp-form-wrapper">
      <h2 className="fp-title">Forget Password</h2>
      <p className="fp-subtitle">Enter Your Register Email ID</p>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4" controlId="fpEmail">
          <Form.Label className="fp-label">Email ID</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email ID"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="fp-input"
            required
          />
        </Form.Group>
        <Button type="submit" className="fp-submit-btn w-100">
          Reset Password
        </Button>
      </Form>
    </div>
  );
};

// Step 2 — Check your email
const CheckEmailStep = ({ onBackToLogin }) => (
  <div className="fp-form-wrapper">
    <h2 className="fp-title">Check Your Email</h2>
    <p className="fp-subtitle">
      We Will Send a link your email , click on link and update Your Password
    </p>
    <Button className="fp-submit-btn w-100" onClick={onBackToLogin}>
      Back To Login
    </Button>
  </div>
);

// Step 3 — Reset password
const ResetPasswordStep = ({ onSubmit }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ password, confirmPassword });
  };

  return (
    <div className="fp-form-wrapper">
      <h2 className="fp-title">Reset Your Password</h2>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="fpPassword">
          <Form.Label className="fp-label">Password</Form.Label>
          <div className="fp-input-eye">
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="fp-input"
              required
            />
            <button
              type="button"
              className="fp-eye-btn"
              onClick={() => setShowPassword(!showPassword)}
              aria-label="Toggle password visibility"
            >
              <EyeIcon show={showPassword} />
            </button>
          </div>
        </Form.Group>

        <Form.Group className="mb-4" controlId="fpConfirmPassword">
          <Form.Label className="fp-label">Confirm Password</Form.Label>
          <div className="fp-input-eye">
            <Form.Control
              type={showConfirm ? 'text' : 'password'}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="fp-input"
              required
            />
            <button
              type="button"
              className="fp-eye-btn"
              onClick={() => setShowConfirm(!showConfirm)}
              aria-label="Toggle confirm password visibility"
            >
              <EyeIcon show={showConfirm} />
            </button>
          </div>
        </Form.Group>

        <Button type="submit" className="fp-submit-btn w-100">
          Update Your Password
        </Button>
      </Form>
    </div>
  );
};

// Main export — manages all 3 steps
export const ForgotPasswordForm = () => {
  const [step, setStep] = useState('email'); // 'email' | 'check-email' | 'reset-password'
  const navigate = useNavigate();

  const handleEmailSubmit = (data) => {
    console.log('Send reset link to:', data.email);
    setStep('check-email');
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  const handleResetSubmit = (data) => {
    console.log('Update password:', data);
    // TODO: connect to API, then navigate to login
    navigate('/login');
  };

  if (step === 'check-email') {
    return <CheckEmailStep onBackToLogin={handleBackToLogin} />;
  }

  if (step === 'reset-password') {
    return <ResetPasswordStep onSubmit={handleResetSubmit} />;
  }

  return <EmailStep onSubmit={handleEmailSubmit} />;
};
